import React from "react";
export default function NearbyCities() {

    return (
           <section id="nearby" className="content-section light nearby-cities">
        <div className="container">
            <h2 className="display-5 fw-bold text-center mb-5 section-title-enhanced">Distances From Nearby Cities</h2>
            <div className="row g-3">
                <div className="col-md-2 col-6">
                    <div className="city-card h-100 text-center">
                        <div className="city-icon">
                            <i className="fas fa-city"></i>
                        </div>
                        <h6 className="city-name">Kolhapur</h6>
                        <p className="city-distance">20 km</p>
                        <small className="city-time">~40 mins</small>
                    </div>
                </div>
                <div className="col-md-2 col-6">
                    <div className="city-card h-100 text-center">
                        <div className="city-icon">
                            <i className="fas fa-city"></i>
                        </div>
                        <h6 className="city-name">Sangli</h6>
                        <p className="city-distance">50 km</p>
                        <small className="city-time">~1.5 hrs</small>
                    </div>
                </div>
                <div className="col-md-2 col-6">
                    <div className="city-card h-100 text-center">
                        <div className="city-icon">
                            <i className="fas fa-city"></i>
                        </div>
                        <h6 className="city-name">Satara</h6>
                        <p className="city-distance">110 km</p>
                        <small className="city-time">~2.5 hrs</small>
                    </div>
                </div>
                <div className="col-md-2 col-6">
                    <div className="city-card h-100 text-center">
                        <div className="city-icon">
                            <i className="fas fa-city"></i>
                        </div>
                        <h6 className="city-name">Belagavi</h6>
                        <p className="city-distance">110 km</p>
                        <small className="city-time">~2.5 hrs</small>
                    </div>
                </div>
                <div className="col-md-2 col-6">
                    <div className="city-card h-100 text-center">
                        <div className="city-icon">
                            <i className="fas fa-city"></i>
                        </div>
                        <h6 className="city-name">Pune</h6>
                        <p className="city-distance">230 km</p>
                        <small className="city-time">~5 hrs</small>
                    </div>
                </div>
                <div className="col-md-2 col-6">
                    <div className="city-card h-100 text-center">
                        <div className="city-icon">
                            <i className="fas fa-city"></i>
                        </div>
                        <h6 className="city-name">Mumbai</h6>
                        <p className="city-distance">380 km</p>
                        <small className="city-time">~7.5 hrs</small>
                    </div>
                </div>
            </div>
            <div className="text-center mt-4">
                <small className="text-muted" style={{fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", fontWeight: 500}}>Times are approximate and may vary with traffic and weather conditions.</small>
            </div>
        </div>
    </section>
    )
}
